// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs-module--tabs--dI3U4","button":"Tabs-module--button--QhsVY","active":"Tabs-module--active--AMzTf"};